// Cambiar "Agotado" por "Sold out"
document.addEventListener('DOMContentLoaded', function() {
  const badges = document.querySelectorAll('.contenedor-tarjeta__badge--sold-out span');
  
  badges.forEach(function(badge) {
    if (badge.textContent.trim() === 'Agotado') {
      badge.textContent = 'Sold out';
    }
  });
});